import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "oz_pro_token";

export const proApi = axios.create({ baseURL: API });
proApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  cfg.headers["X-Admin-Token"] = localStorage.getItem("oz_admin_token") || "";
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Une erreur est survenue. Merci de réessayer.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return String(d.msg || d);
}

export const eur = (cents) =>
  (cents / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });

export const eurNum = (n) => n.toLocaleString("fr-FR", { style: "currency", currency: "EUR" });

export const imgSrc = (src) => (src && src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src);

export const COUNTRIES = [
  ["FR", "France"], ["BE", "Belgique"], ["LU", "Luxembourg"], ["CH", "Suisse"], ["MC", "Monaco"],
  ["DE", "Allemagne"], ["ES", "Espagne"], ["IT", "Italie"], ["NL", "Pays-Bas"], ["PT", "Portugal"],
];

export const feeLabel = (v, free = "gratuit") => (v ? `${String(v).replace(".", ",")} € HT` : free);
